<template>
  <div>
    <!-- <ModalSite :site-id="siteId" /> -->
  </div>
</template>

<script>
export default {
  components: {
    // ModalChatBot: () => import('@/components/admin/monitor/modals/ChatBot'),
  },

  data() {
    return {
      group: 'crawler',
    };
  },

  created() {
    this.setupEventListeners();
  },

  beforeDestroy() {
    Bus.$off('toggle_modal');
    Bus.$off('set_modal_model_id');
    Bus.$off('inspect_post');
  },

  methods: {
    setupEventListeners() {
      Bus.$on('inspect_post', (pid) => {
        Bus.$emit('toggle_modal', 'post', pid);
      });

      Bus.$on('toggle_modal_with_model', (group, modal, modelId) => {
        if (group === this.group) {
          // console.log('modals.toggle_modal', modal, modelId);
          Bus.$emit('fetcher', 'set_modal_model_id', modal, modelId);
          Bus.$emit('toggle_modal', modal);
        }
      });

      Bus.$on('set_modal_model_id', (group, modal, modelId) => {
        if (group === this.group) {
          // console.log(`setting ${modal}Id to ${modelId}`);
          this[`${modal}Id`] = modelId;
        }
      });
    },
  },
};
</script>
